// ---------------------------------------------------------------------------
// integrations/index.ts — Aggregator for all integration content records
// ---------------------------------------------------------------------------
import type { IntegrationRecord } from './types';
export type { IntegrationRecord, IntegrationLandingContent, IntegrationConstants } from './types';

import { STRIPE_INTEGRATION } from './stripe.content';
import { PAYPAL_INTEGRATION } from './paypal.content';
import { RAZORPAY_INTEGRATION } from './razorpay.content';
import { BOOKING_COM_INTEGRATION } from './booking-com.content';
import { EXPEDIA_INTEGRATION } from './expedia.content';
import { AIRBNB_INTEGRATION } from './airbnb.content';
import { AGODA_INTEGRATION } from './agoda.content';
import { AMADEUS_GDS_INTEGRATION } from './amadeus-gds.content';
import { MAKEMYTRIP_INTEGRATION } from './makemytrip.content';
import { GOIBIBO_INTEGRATION } from './goibibo.content';
import { HOSTELWORLD_INTEGRATION } from './hostelworld.content';
import { TRIPADVISOR_INTEGRATION } from './tripadvisor.content';
import { SABRE_GDS_INTEGRATION } from './sabre-gds.content';
import { APPLE_PAY_INTEGRATION } from './apple-pay.content';
import { GOOGLE_PAY_INTEGRATION } from './google-pay.content';
import { PAYMENTHOOKS_INTEGRATION } from './paymenthooks.content';
import { EVENTHOOKS_INTEGRATION } from './eventhooks.content';

/** All integration records keyed by slug. */
export const INTEGRATION_CONTENT: Record<string, IntegrationRecord> = {
  'stripe': STRIPE_INTEGRATION,
  'paypal': PAYPAL_INTEGRATION,
  'razorpay': RAZORPAY_INTEGRATION,
  'booking-com': BOOKING_COM_INTEGRATION,
  'expedia': EXPEDIA_INTEGRATION,
  'airbnb': AIRBNB_INTEGRATION,
  'agoda': AGODA_INTEGRATION,
  'amadeus-gds': AMADEUS_GDS_INTEGRATION,
  'makemytrip': MAKEMYTRIP_INTEGRATION,
  'goibibo': GOIBIBO_INTEGRATION,
  'hostelworld': HOSTELWORLD_INTEGRATION,
  'tripadvisor': TRIPADVISOR_INTEGRATION,
  'sabre-gds': SABRE_GDS_INTEGRATION,
  'apple-pay': APPLE_PAY_INTEGRATION,
  'google-pay': GOOGLE_PAY_INTEGRATION,
  'paymenthooks': PAYMENTHOOKS_INTEGRATION,
  'eventhooks': EVENTHOOKS_INTEGRATION,
};
